import { Container } from 'reactstrap';
import ModifFormPovrch from '../comp/ModifFormPovrch'

function NewPovrch() {
    return (
    <Container>
        <ModifFormPovrch edit={false} />
    </Container>)
}
export default NewPovrch